'use client'
import { useEffect, useRef } from 'react'

export default function RuntimeHtml({ html }: { html: string }) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const root = ref.current
    if (!root) return
    const scripts = Array.from(root.querySelectorAll('script'))
    for (const oldScript of scripts) {
      const script = document.createElement('script')
      for (const attr of Array.from(oldScript.attributes)) script.setAttribute(attr.name, attr.value)
      script.textContent = oldScript.textContent || ''
      oldScript.replaceWith(script)
    }
    // Generated pages commonly register DOMContentLoaded handlers. Since this runs after
    // hydration, replay the event once so those handlers initialize in the live document.
    queueMicrotask(() => document.dispatchEvent(new Event('DOMContentLoaded')))
    return () => { for (const script of root.querySelectorAll('script')) script.remove() }
  }, [html])
  return <div ref={ref} suppressHydrationWarning dangerouslySetInnerHTML={{ __html: html }} />
}
